import { Component, Input, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IconComponent, IconSourceEnum } from '../../../../@core/components/ui/icon/icon.component';
import { FollowUpsService } from '../../../../features/general-agent/services/follow-ups.service';

@Component({
  selector: 'app-custom-follow-up-suggestions',
  standalone: true,
  imports: [CommonModule, IconComponent],
  templateUrl: './custom-follow-up-suggestions.component.html',
  styleUrl: './custom-follow-up-suggestions.component.scss'
})
export class CustomFollowUpSuggestionsComponent {
  @Input() followUps: string[] = [];

  private followUpsService = inject(FollowUpsService);
  IconSourceEnum = IconSourceEnum;

  handleFollowUpClick(question: string) {
    this.followUpsService.emitFollowUpClick(question);
  }
}
